import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldMessage } from '../atoms/FieldMessage/FieldMessage.js';
import { fieldLabelClasses } from './field-styles.js';
import { useTranslate } from './i18n.js';
/**
 * Label, and the optional marker at the far end of the same row.
 *
 * The marker sits in the label row rather than in the helper text below,
 * because the helper row is where errors go: "Optional" living there made a
 * field one line taller than its neighbours and pushed its label out of line
 * with theirs, and it vanished the moment the field went wrong.
 */
export function FieldLabel({ htmlFor, children, optional, labelId }) {
    return (_jsxs("div", { className: "flex items-baseline justify-between gap-3", children: [_jsx("label", { ...(labelId ? { id: labelId } : {}), htmlFor: htmlFor, className: fieldLabelClasses, children: children }), optional ? _jsx(OptionalMarker, {}) : null] }));
}
/**
 * The helper-or-error row.
 *
 * When reserved, the empty state renders the same component holding a
 * non-breaking space rather than a fixed height in pixels: the row is then
 * exactly one line of the real type, and a change to the type scale cannot
 * leave the reservation half a line short. It is hidden from assistive
 * technology, which has nothing to gain from a blank line.
 */
export function FieldMessageSlot({ id, message, isError, reserve }) {
    if (!message && !reserve)
        return null;
    return (_jsx(FieldMessage, { ...(message ? { id } : { 'aria-hidden': true }), tone: isError ? 'error' : 'helper', children: message ?? ' ' }));
}
/**
 * The word beside a label a field does not require.
 *
 * Its own component only because a hook has to live in one, and the row it
 * sits in renders from several places.
 */
function OptionalMarker() {
    const t = useTranslate();
    return _jsx("span", { className: "text-caption text-text-muted", children: t('ui.field.optional') });
}
//# sourceMappingURL=field-parts.js.map